

























































































































































































































































































































































































































import Vue from "vue";
import SideBar from "@/parts/about/SideBar.vue";
import ReturnTop from "@/parts/util/ReturnTop.vue";

/** 利用規約 */
export default Vue.extend({
  name: "Terms",
  components: {
    SideBar,
    ReturnTop,
  },
});
